/* --- AVAILABILITY MODULE --- */
export const GET_RIDER_AVAILABILITY_LIST = "GET_RIDER_AVAILABILITY_LIST";
export const GET_RIDER_AVAILABILITY_MAP = "GET_RIDER_AVAILABILITY_MAP";
